import { SmartDataTable } from '@src/components/SmartDataTable';
import { useManufacturersColumns, useManufacturersFormFields } from './hooks';

export const ManufacturersPage = () => {
  const columns = useManufacturersColumns();
  const formFields = useManufacturersFormFields();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SmartDataTable
        api={{
          resource: 'manufacturers',
        }}
        title="Manufacturers"
        columns={columns}
        search={{
          enabled: true,
          fields: ['manufacturer', 'contact_person', 'phone'],
          placeholder:
            'Search by manufacturer name, contact person, or phone...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields as any,
          title: 'Add New Manufacturer',
          submitText: 'Add Manufacturer',
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Manufacturer',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        isFilter={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 300px)',
          },
        }}
        rowKey="id"
        style={{
          width: '100%',
          overflow: 'hidden',
        }}
      />
    </div>
  );
};
